export default {
  form: {
    font_family: {
      label: 'Police de caractères',
    },
    header: {
      label: 'En-tête',
      placeholder: 'En-tête',
    },
    sub_header: {
      label: 'Sous-titre',
      placeholder: 'Sous-titre',
    },
    qr_code_header: {
      label: 'En-tête du bloc UI',
      placeholder: 'En-tête du bloc UI',
    },
    qr_code_description: {
      label: 'Description du bloc UI',
      placeholder: 'Description du bloc UI',
    },
    footer: {
      label: 'Texte du pied de page',
      placeholder: 'Saisir le pied de page',
    },
    url_type: {
      label: 'URL',
      placeholder: 'Sélectionner une URL',
    },
    url: {
      placeholder: 'www.example.com',
    },
    primary_color: {
      label: 'Couleur principale',
    },
    background_color: {
      label: 'Couleur de fond',
    },
    cover_image: {
      label: 'Image de couverture',
    },
    logo: {
      label: 'Logo',
    },
    logo_zoom: {
      label: 'Zoom du logo',
    },
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement du sticker de porte',
  },
};
